<!-- eslint-disable prettier/prettier -->
<template>
    <v-container fluid>
        <v-card>
            <v-toolbar dark color="secondary" class="white--text" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                   Driver Badges
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container fluid>
                <v-form ref="form" lazy-validation>
                    <v-row class="">
                        <v-col cols="12" md="3">
                            <v-combobox label="Select Driver" :items="drivers" chips dense :item-text="'Name'"
                                :item-value="'id'" auto-select-first v-model="driver"
                                @change="chargeData()"></v-combobox>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-text-field label="Driver ID" dense v-model="driver.id" outlined readonly>
                                <template v-slot:append>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-show="driver" v-on="on"
                                                color="primary">mdi-information-outline</v-icon>
                                        </template>
                                        <span>Driver Name:
                                            <b>{{ driver.Name }}</b></span><br />
                                        <span>Driver ID:
                                            <b>{{ driver.id }}</b></span><br />
                                        <br />
                                        <span>Driver Status:
                                            <b>{{
                                                driver.Active
                                                    ? 'Active'
                                                    : 'Inactive'
                                            }}</b></span><br />
                                        <span>Driver Address:
                                            <b>{{ driver.Address }}</b></span><br />
                                        <span>Driver City:
                                            <b>{{ driver.City }}</b></span><br />
                                        <span>Driver Province:
                                            <b>{{ driver.Province }}</b></span><br />
                                        <span>Driver Postal Code:
                                            <b>{{ driver.PostalCode }}</b></span><br />
                                        <span>Driver Birth Date:
                                            <b>{{ driver.BirthDate }}</b></span><br />
                                        <br />
                                        <span>Driver Email:
                                            <b>{{ driver.Email }}</b></span><br />
                                        <span>Driver Phone 1:
                                            <b>{{ driver.Telephone }}</b></span><br />
                                        <span>Driver Phone 2:
                                            <b>{{ driver.Telephone2 }}</b></span><br />
                                        <span>Driver SIN:
                                            <b>{{ driver.SIN }}</b></span><br />
                                    </v-tooltip>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                    </v-row>
                    <v-row v-show="driver">
                        <v-col cols="12">
                            <v-card>
                                <v-tabs height="47" color="teal" grow>
                                    <v-tab slider-color="secondary" @click="nav = 1">
                                        <v-icon>mdi-shield-star</v-icon>
                                        Badges to Load
                                    </v-tab>
                                    <v-tab slider-color="secondary" @click="nav = 2">
                                        <v-icon>mdi-shield-star</v-icon>
                                        Badges to UnLoad
                                    </v-tab>
                                </v-tabs>

                                <v-col cols="12" v-if="nav == 1">
                                    <v-data-table :headers="badgeHeaders" :items="badgesLoad" dense fixed-header
                                        hide-default-footer disable-pagination class="white">
                                        <template v-slot:item.TerminalName="{ item }">
                                            <v-icon :color="item.Color">
                                                mdi-circle
                                            </v-icon>
                                            {{ item.TerminalName }}
                                        </template>

                                        <template v-slot:item.BadgeNumber="{ item }">
                                            <v-text-field dense v-model="item.BadgeNumber" type="number" readonly
                                                hide-details></v-text-field>
                                        </template>

                                        <template v-slot:item.IsPermittedToUnload="{
                                            item
                                        }">
                                            <v-checkbox v-model="item.IsPermittedToUnload
                                                " class="ma-0" dense hide-details />
                                        </template>
                                        <template v-slot:item.IsPermittedToLoad="{
                                            item
                                        }">
                                            <v-checkbox v-model="item.IsPermittedToLoad
                                                " class="ma-0" dense hide-details />
                                        </template>
                                        <template v-slot:item.last_order="{ item }">
                                            {{
                                                item.last_order === null  ? 'N/A' :item.last_order.OrderID  
                                            }}
                                            <!--Create a tooltip inside an info icon to display additional data-->
                                            <v-tooltip v-if="item.last_order" bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon v-on="on" color="primary">mdi-information-outline</v-icon>
                                                </template>
                                                <div>
                                                    <span>ShiftDetail:
                                                        <b>{{
                                                            item.last_order
                                                                .ShiftDetail
                                                        }}</b></span><br />
                                                    <span>Order Number:
                                                        <b>{{
                                                            item.last_order
                                                                .OrderID
                                                        }}</b></span><br />
                                                    <span>Order Delivery Date:
                                                        <b>{{
                                                            item.last_order
                                                                .DateDelivered
                                                        }}</b></span><br />
                                                    <span>Order Status:
                                                        <b>{{
                                                            item.last_order
                                                                .OrderStatus
                                                        }}</b></span><br />
                                                    <span>Order Load Status:
                                                        <b>{{
                                                            item.last_order
                                                                .OrdLoadStatus
                                                        }}</b></span><br />
                                                    <v-spacer></v-spacer>
                                                    <span>Orders in the last
                                                        Year:
                                                        <b>{{
                                                            item.OrderCountInLastYear
                                                        }}</b></span><br />
                                                    <span>Orders in the last 180
                                                        Days:
                                                        <b>{{
                                                            item.OrderCountInLast180Days
                                                        }}</b></span>
                                                </div>
                                            </v-tooltip>
                                        </template>

                                        <template v-slot:item.InactiveBadgeExpirationCountdown="{
                                            item
                                        }">
                                            <v-icon>mdi-timer-sand</v-icon>
                                            <span :class="getExpirationColor(
                                                item.InactiveBadgeExpirationCountdown
                                            )
                                                ">{{
                                                    item.InactiveBadgeExpirationCountdown === null
                                                        ? 'N/A' : item.InactiveBadgeExpirationCountdown + ' Days left '
                                                }}</span>
                                            <!--Create a tooltip inside an info icon to display additional data-->
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon v-show="item.InactiveBadgeExpirationCountdown
                                                        " v-on="on" color="primary">mdi-information-outline</v-icon>
                                                </template>
                                                <span>Badge expires at:
                                                    {{
                                                        item.InactiveBadgeExpirationDate
                                                    }}</span><br />
                                                <span>Terminal expiration period:
                                                    {{
                                                        item.InactiveBadgeExpirationPeriod
                                                    }}
                                                    Days.</span>
                                            </v-tooltip>
                                            <!--<v-text-field dense v-model="item.InactiveBadgeExpirationPeriod" hide-details readonly>
                      </v-text-field>-->
                                        </template>

                                        <template v-slot:item.ExpirationDate="{ item }">
                                            <div class="ma-2">
                                                <v-text-field class="pt-2 pb-1" compact label="Expiration Date" v-model="item.ExpirationDate
                                                    " :rules="$store.state.dateRules
                                                        " v-mask="$store.state.mask" hide-details readonly>
                                                    <template v-slot:prepend>
                                                        <v-icon>mdi-clock-fast</v-icon>
                                                    </template>
                                                </v-text-field>
                                            </div>
                                        </template>
                                        <template v-slot:item.LastActiveDate="{ item }">
                                            <v-text-field class="pt-2 pb-1" dense label="Inactive Expiration Date"
                                                v-model="item.LastActiveDate
                                                    " :rules="$store.state.dateRules
                                                            " v-mask="$store.state.mask" hide-details readonly>
                                                <template v-slot:prepend>
                                                    <v-icon>mdi-clock-alert-outline</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <template v-slot:item.OrientationExpDate="{ item }">
                                            <v-text-field class="pt-2" dense label="Orientation Expiration Date" readonly
                                                v-model="item.OrientationExpDate
                                                    " :rules="$store.state.dateRules
                                                            " v-mask="$store.state.mask" hide-details>
                                                <template v-slot:prepend>
                                                    <v-icon>mdi-clock-end</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <template v-slot:item.IsActive="{ item }">
                                            <v-checkbox v-model="item.IsActive" readonly class="ma-0" :color="item.IsActive == 1 &&
                                                item.LockedOut == 0
                                                ? 'green'
                                                : 'red'
                                                " hide-details :disabled="item.LockedOut == 1">
                                                <template v-slot:label>
                                                    <span v-if="
                                                        item.IsActive ==
                                                        1 &&
                                                        item.LockedOut ==
                                                        0
                                                    " class="green--text">Active</span>
                                                    <span v-else-if="
                                                        item.IsActive ==
                                                        1 &&
                                                        item.LockedOut ==
                                                        1
                                                    " class="gray--text">Locked</span>
                                                    <span v-else class="red--text">Inactive</span>
                                                </template>
                                            </v-checkbox>
                                            <v-checkbox v-model="item.LockedOut" readonly v-show="item.IsActive == 1 ||
                                                item.LockedOut == 1
                                                " class="ma-0" hide-details :label="item.LockedOut
                                                    ? 'Locked'
                                                    : 'Unlocked'
                                                    "></v-checkbox>
                                        </template>

                                    </v-data-table>
                                </v-col>

                                <v-col cols="12" v-if="nav == 2">
                                    <v-data-table :headers="badgeHeaders" :items="badgesUnLoad" dense fixed-header
                                        hide-default-footer disable-pagination class="white">
                                        <template v-slot:item.TerminalName="{ item }">
                                            <v-icon :color="item.Color">
                                                mdi-circle
                                            </v-icon>
                                            {{ item.TerminalName }}
                                        </template>

                                        <template v-slot:item.BadgeNumber="{ item }">
                                            <v-text-field dense v-model="item.BadgeNumber" type="number" readonly
                                                hide-details></v-text-field>
                                        </template>

                                        <template v-slot:item.IsPermittedToUnload="{
                                            item
                                        }">
                                            <v-checkbox v-model="item.IsPermittedToUnload
                                                " class="ma-0" dense hide-details />
                                        </template>
                                        <template v-slot:item.IsPermittedToLoad="{
                                            item
                                        }">
                                            <v-checkbox v-model="item.IsPermittedToLoad
                                                " class="ma-0" dense hide-details />
                                        </template>
                                        <template v-slot:item.last_order="{ item }">
                                            {{
                                                item.last_order === null  ? 'N/A' :item.last_order.OrderID  
                                            }}
                                            <!--Create a tooltip inside an info icon to display additional data-->
                                            <v-tooltip v-if="item.last_order" bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon v-on="on" color="primary">mdi-information-outline</v-icon>
                                                </template>
                                                <div>
                                                    <span>ShiftDetail:
                                                        <b>{{
                                                            item.last_order
                                                                .ShiftDetail
                                                        }}</b></span><br />
                                                    <span>Order Number:
                                                        <b>{{
                                                            item.last_order
                                                                .OrderID
                                                        }}</b></span><br />
                                                    <span>Order Delivery Date:
                                                        <b>{{
                                                            item.last_order
                                                                .DateDelivered
                                                        }}</b></span><br />
                                                    <span>Order Status:
                                                        <b>{{
                                                            item.last_order
                                                                .OrderStatus
                                                        }}</b></span><br />
                                                    <span>Order Load Status:
                                                        <b>{{
                                                            item.last_order
                                                                .OrdLoadStatus
                                                        }}</b></span><br />
                                                    <v-spacer></v-spacer>
                                                    <span>Orders in the last
                                                        Year:
                                                        <b>{{
                                                            item.OrderCountInLastYear
                                                        }}</b></span><br />
                                                    <span>Orders in the last 180
                                                        Days:
                                                        <b>{{
                                                            item.OrderCountInLast180Days
                                                        }}</b></span>
                                                </div>
                                            </v-tooltip>
                                        </template>

                                        <template v-slot:item.InactiveBadgeExpirationCountdown="{
                                            item
                                        }">
                                            <v-icon>mdi-timer-sand</v-icon>
                                            <span :class="getExpirationColor(
                                                item.InactiveBadgeExpirationCountdown
                                            )
                                                ">{{
                                                    item.InactiveBadgeExpirationCountdown === null
                                                        ? 'N/A' : item.InactiveBadgeExpirationCountdown + ' Days left '
                                                }}</span>
                                            <!--Create a tooltip inside an info icon to display additional data-->
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon v-show="item.InactiveBadgeExpirationCountdown
                                                        " v-on="on" color="primary">mdi-information-outline</v-icon>
                                                </template>
                                                <span>Badge expires at:
                                                    {{
                                                        item.InactiveBadgeExpirationDate
                                                    }}</span><br />
                                                <span>Terminal expiration period:
                                                    {{
                                                        item.InactiveBadgeExpirationPeriod
                                                    }}
                                                    Days.</span>
                                            </v-tooltip>
                                            <!--<v-text-field dense v-model="item.InactiveBadgeExpirationPeriod" hide-details readonly>
                      </v-text-field>-->
                                        </template>

                                        <template v-slot:item.ExpirationDate="{ item }">
                                            <div class="ma-2">
                                                <v-text-field class="pt-2 pb-1" compact label="Expiration Date" v-model="item.ExpirationDate
                                                    " :rules="$store.state.dateRules
                                                        " v-mask="$store.state.mask" hide-details readonly>
                                                    <template v-slot:prepend>
                                                        <v-icon>mdi-clock-fast</v-icon>
                                                    </template>
                                                </v-text-field>
                                            </div>
                                        </template>
                                        <template v-slot:item.InactiveBadgeExpirationDate="{ item }">
                                            <v-text-field class="pt-2 pb-1" dense label="Inactive Expiration Date"
                                                v-model="item.InactiveBadgeExpirationDate
                                                    " :rules="$store.state.dateRules
                                                            " v-mask="$store.state.mask" hide-details readonly>
                                                <template v-slot:prepend>
                                                    <v-icon>mdi-clock-alert-outline</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <template v-slot:item.OrientationExpDate="{ item }">
                                            <v-text-field class="pt-2" dense label="Orientation Expiration Date" readonly
                                                v-model="item.OrientationExpDate
                                                    " :rules="$store.state.dateRules
                                                            " v-mask="$store.state.mask" hide-details>
                                                <template v-slot:prepend>
                                                    <v-icon>mdi-clock-end</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <template v-slot:item.IsActive="{ item }">
                                            <v-checkbox v-model="item.IsActive" class="ma-0" readonly :color="item.IsActive == 1 &&
                                                item.LockedOut == 0
                                                ? 'green'
                                                : 'red'
                                                " hide-details :disabled="item.LockedOut == 1">
                                                <template v-slot:label>
                                                    <span v-if="
                                                        item.IsActive ==
                                                        1 &&
                                                        item.LockedOut ==
                                                        0
                                                    " class="green--text">Active</span>
                                                    <span v-else-if="
                                                        item.IsActive ==
                                                        1 &&
                                                        item.LockedOut ==
                                                        1
                                                    " class="gray--text">Locked</span>
                                                    <span v-else class="red--text">Inactive</span>
                                                </template>
                                            </v-checkbox>
                                            <v-checkbox v-model="item.LockedOut" readonly v-show="item.IsActive == 1 ||
                                                item.LockedOut == 1
                                                " class="ma-0" hide-details :label="item.LockedOut
                                                    ? 'Locked'
                                                    : 'Unlocked'
                                                    "></v-checkbox>
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-card>
                        </v-col>
                    </v-row>
                    <!--Show a Skeleton loader if "driver" is null | hcobian -->
                    <template v-if="!driver">
                        <v-alert type="info" dismissible>
                            Please select a driver to display their badges and
                            credentials.
                        </v-alert>
                        <v-skeleton-loader v-if="!driver" type="table" :loading="true"
                            height="50vh"></v-skeleton-loader>
                    </template>
                </v-form>
            </v-container>
        </v-card>

    </v-container>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
export default {
    directives: { mask },
    data: function () {
        return {
            
            cpmt: 'Driver Credential',
            load_dialog_badge: false,
            unload_dialog_badge: false,
            dialog_alert: false,
            tooltip: {
                left: true,
                top: true
            },
            type: '',
            terminals: [],
            report: [],
            alerts:[],
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ],
            credentialHeaders: [
                {
                    text: 'Credential',
                    value: 'credential_type.CredType'
                },
                {
                    text: 'Credential number',
                    value: 'CredNumber'
                },
                {
                    text: 'Expiration date',
                    value: 'CredExpiry'
                },
                { text: 'Actions', value: 'actions', sortable: false }
            ],
            badgeHeaders: [
                { text: 'Terminal', value: 'TerminalName' },
                { text: 'Badge Number', value: 'BadgeNumber' },
                // { text: 'UnLoad', value: 'IsPermittedToUnload' },
                // { text: 'Load', value: 'IsPermittedToLoad' },
                {
                    text: 'Last Load/Unload',
                    value: 'last_order',
                    sortable: false
                },
                {
                    text: 'Inactivity Expiration Countdown (IEC)',
                    value: 'InactiveBadgeExpirationCountdown'
                },
                {
                    text: 'Last Active Date',
                    value: 'LastActiveDate'
                },
                {
                    text: 'Expiration Date',
                    value: 'ExpirationDate'
                },

                {
                    text: 'Orientation Exp Date',
                    value: 'OrientationExpDate'
                },
                { text: 'Status', value: 'IsActive' },
                //{ text: 'Lockout', value: 'LockedOut'},
                { text: 'Comments', value: 'Comments' },
            ],
            badgeReportHeaders: [
                { text: 'Driver', value: 'driver.Name' },
                { text: 'Terminal', value: 'terminal.TerminalName' },
                { text: 'Badge ID', value: 'BadgeNumber' },
                { text: 'Type', value: 'IsPermittedToUnload' },
                { text: 'Last Load/Unload', value: 'LastActiveDate' },
                {
                    text: 'Inactivity Expiration Countdown (IEC)',
                    value: 'InactiveBadgeExpirationCountdown'
                },

                {
                    text: 'Last Active Date',
                    value: 'LastActiveDate'
                },
                {
                    text: 'Expiration Date',
                    value: 'ExpirationDate'
                },

                {
                    text: 'Orientation Exp Date',
                    value: 'OrientationExpDate'
                },

                { text: 'Expiration Date', value: 'ExpirationDate' },
                { text: 'Status', value: 'IsActive' },
                { text: 'Lockout', value: 'LockedOut' },
                { text: 'Comments', value: 'Comments' }
            ],
            credentialReportHeaders: [
                { text: 'Driver', value: 'driver.Name' },
                { text: 'Credential', value: 'credential_type.CredType' },
                { text: 'Credential number', value: 'CredNumber' },
                { text: 'Creation date', value: 'CreationDate' },
                { text: 'Expiration date', value: 'CredExpiry' }
            ],
            reportHeaders: [],
            drivers: [],
            badgesLoad: [],
            badgesUnLoad: [],
            count: 0,
            credential: [],
            credentials: [],
            driver: '',
            nav: 1
        };
    },
    mounted() {
        this.loadDrivers();
    },
    watch: {
        '$store.state.BadgeCred.watch': function () {
            if (this.$store.state.BadgeCred.watch == true) {
                this.chargeData();
                this.$store.state.BadgeCred.watch = false;
            }
        }
    },
    methods: {
        CleanBadge: function (nav) {
            axios
                .post('driver-badge/clear', { Driver: this.driver.id, BadgeType: nav }, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Clean Badges successfully'
                    });
                    this.chargeData();
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        this.$store.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        this.$store.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        closeRecall: function () {
            this.load_dialog_badge = false;
            this.unload_dialog_badge = false;
            this.chargeData();
        },
        loadDrivers: function () {
            axios
                .get('driver/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.drivers = response.data.data;
                    console.table(this.drivers);
                    this.$store.dispatch('setSnackbar', {
                        color: 'secondary',
                        text: 'Select a Driver'
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        loadBadges: function () {
            console.log(this.driver);
            this.terminals = [];
            this.$store.state.isLoading = true;
            axios
                .get('driver-badge/all/' + this.driver.id, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.badgesLoad = response.data['Load'];
                    this.badgesUnLoad = response.data['UnLoad'];
                    console.log(this.badgesLoad);
                    this.badgesLoad.forEach(element => {
                        this.terminals.push(element.TerminalID);
                    });
                    console.log(this.terminals);
                    this.$store.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    this.$store.state.isLoading = false;
                });
        },
        
        chargeData: async function () {
            this.badge = [];
            this.credential = [];
            await this.loadBadges();
        },
        createReport: function (days = 30, type = 'badge') {
            this.$store.state.isLoading = true;
            this.report = [];
            if (type == 'badge') {
                this.type = 'badge';
                this.loadBadgeReport(days);
            } else if (type == 'credential') {
                this.type = 'credential';
                this.loadCredentialReport(days);
            }
        },
        getDaysUntilDate(date) {
            var today = new Date();
            var date2 = new Date(date);
            var diffTime = date2 - today;
            var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            return diffDays >= 0
                ? diffDays + ' Days left.'
                : -diffDays + ' Days ago.';
        },
        getExpirationColor: function (days, type = 'class') {
            if (type == 'color') {
                if (days <= 30) {
                    return 'red';
                } else if (days <= 60) {
                    return 'orange';
                } else {
                    return 'green';
                }
            } else if (type == 'class') {
                if (days <= 30) {
                    return 'red--text';
                } else if (days <= 60) {
                    return 'orange--text';
                } else {
                    return 'green--text';
                }
            }
        },
        getExpirationDate: function (days) {
            var today = new Date();
            var date = new Date(today);
            date.setDate(date.getDate() + days);
            return date.toLocaleDateString();
        },
        async cleanBadgesCredential() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to clear all the badges assigned to this driver',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.CleanBadge(this.nav);

            }
        },
    }
};
</script>

<!--<style>
.divs {
  margin-top: 0px;
  padding-top: 0px;
}

.chps {
  width: 10px;
}
</style>
-->
